import React from 'react';
import { useParams, useLocation, Redirect } from 'react-router-dom';
import PlanView from 'screens/Plans/components/PlanView';
import usePlansFlags from 'screens/Plans/redesign/hooks/usePlansFlags';
import { paths } from 'routes/paths';

/**
 * Route guard for the legacy `/app/plans/:id/view` URL.
 *
 * When the redesign flag is active (FR-002a) the full-page detail route is
 * superseded by the inline detail panel on the Plans list. Any direct link to
 * `/app/plans/:id/view` is transparently redirected to `/app/plans` with
 * `{ selectedPlanId: id }` in route state so the landing can pre-open the
 * correct row's detail panel (see contracts/plans-flag-gating.md's
 * "Deep-link preselection" section — the receiving `PlansPage` consumes this
 * via `useDeepLinkSelection`, not by reading `location.state` directly).
 *
 * When the flag is off the legacy `<PlanView>` renders as before.
 */
const PlanViewGuard: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const { fePlansActive } = usePlansFlags();

  if (fePlansActive) {
    return (
      <Redirect
        to={{
          pathname: paths.plans,
          search: location.search,
          state: { selectedPlanId: id }
        }}
      />
    );
  }

  return <PlanView />;
};

export default PlanViewGuard;
